import React from "react";
export const TableLoader = () => {
    return (
        <div className='text-center my-3'>
            <i data-testid="loading-spinner" className='fa fa-spinner fa-spin fa-3x mb-1' style={{ opacity: '.5' }}></i>
            <p className="mb-0">Loading, please wait...</p>
        </div>
    )
}

export const TableWithNoData = ({setPending}) => {
    const realod = () => {
        setPending(true)
        setTimeout(()=>{
            setPending(false)}, 5000);

    }
    return (
        <div className='w-100 text-center py-5'>
            <p>There are no records to display!</p>
            <button className="btn pharma-bg text-white" onClick={(e) => {realod()}}>Try Again</button>
        </div>
    )
}
    